
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useEntryTracking = (entryId: string) => {
  const { user } = useAuth();

  useEffect(() => {
    if (!entryId) return;

    const logAccess = async () => {
      try {
        await supabase.rpc('log_entry_access', {
          p_entry_id: entryId,
          p_user_id: user?.id || null,
          p_user_display_name: user?.email?.split('@')[0] || 'Unknown'
        });
      } catch (error) {
        console.error("Error logging entry access:", error);
      }
    };

    logAccess();
  }, [entryId, user]);

  const trackSave = async () => {
    if (!user?.id) return false;
    
    try {
      const { data, error } = await supabase.rpc('track_entry_save', {
        p_entry_id: entryId,
        p_user_id: user.id
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error tracking save:", error);
      return false;
    }
  };

  return { trackSave };
};
